import { Application } from "@vendors/stimulus";
import qvp from "@vendors/qvp";
import { scrollCue } from "@vendors/scrollcue";
import { customer, patch } from "session";
import { supportsViewTransitions } from "@utils/core";
console.log("[theme.js]:", customer, scrollCue);

function reigsterViewports() {
  const viewports = [
    {
      query: "(max-width: 640px)",
      name: "xs",
    },
    {
      query: "(min-width: 640px) and (max-width: 768px)",
      name: "sm",
    },
    {
      query: "(min-width: 768px) and (max-width: 1024px)",
      name: "md",
    },
    {
      query: "(min-width: 1024px)",
      name: "lg",
    },
  ];

  const qvpItems = viewports.map((viewport) => ({
    id: viewport.name,
    query: viewport.query,
    onenter: () => {
      document.dispatchEvent(
        new Event("viewport:enter", {
          detail: {
            viewport: viewport.name,
          },
        })
      );
    },
    onexit: () => {
      document.dispatchEvent(
        new Event("viewport:exit", {
          detail: {
            viewport: viewport.name,
          },
        })
      );
    },
  }));

  qvp(qvpItems);

  window.WIP.viewports = qvp;
}

function app() {
  const application = Application.start();
  window.Stimulus = application;

  application.debug = true;
  application.pendingControllers = [];

  application.lazyload = (controller) => {
    application.pendingControllers.push(controller);
    return import(`@controllers/${controller}`).then(
      (module) => module.default
    );
  };

  application.loadAndRegister = (identifier) => {
    if (application.pendingControllers.includes(identifier)) return true;
    application.lazyload(identifier).then((ControllerClass) => {
      application.register(identifier, ControllerClass);
    });
  };

  function idleRegistry(element) {
    const controllers = element.dataset.controller.split(" ");

    controllers.forEach((identifier) => {
      if (!application.router.modules.includes(identifier)) {
        requestIdleCallback(() => {
          application.loadAndRegister(identifier);
        });
      }
    });
  }

  function handleIntersectionObserverCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const controllers = entry.target.dataset.controller.split(" ");

        controllers.forEach((identifier) => {
          if (!application.router.modules.includes(identifier)) {
            application.loadAndRegister(identifier);
          }
        });

        //   application.lazyload(controller).then((ControllerClass) => {});
      }
    });
  }

  const observer = new IntersectionObserver(
    handleIntersectionObserverCallback,
    {
      rootMargin: `0px 0px ${window.innerHeight * 0.25}px 0px`,
      threshold: 0.01,
    }
  );

  function registerControllerNode(element) {
    const { loadStrategy = "visible" } = element.dataset;

    if (loadStrategy === "visible") {
      observer.observe(element);
    } else if (loadStrategy === "idle") {
      idleRegistry(element);
    } else {
      // do an 'any' interaction strategy
    }
  }

  const $controllers = [...document.querySelectorAll("[data-controller]")];

  $controllers.forEach((element) => registerControllerNode(element));

  function registerControllerWatchers() {
    const nodes = document.querySelectorAll("[data-controller]");

    nodes.forEach((element) => {
      if (!$controllers.includes(element)) {
        registerControllerNode(element);
        $controllers.push(element);
      }
    });
  }

  ["cart:update"].forEach((event) => {
    document.addEventListener(event, () => registerControllerWatchers());
  });
}

function init() {
  reigsterViewports();

  scrollCue.init({
    duration: 300,
    percentage: 0.95,
  });
  app();
}

init();
